import { ScreenSize, mdsBreakpointsValue } from "@/design-system/foundations";

export const mdsMediaQueriesValue = {
  rules: Object.fromEntries(
    Object.entries(mdsBreakpointsValue).map(([mode, breakpoint]) => [
      mode as ScreenSize,
      `@media ${breakpoint}`,
    ])
  ) as Record<ScreenSize, string>,
  exclusion: {
    rules: Object.fromEntries(
      Object.entries(mdsBreakpointsValue).map(([mode, breakpoint]) => [
        mode as ScreenSize,
        `@media not all and ${breakpoint}`,
      ])
    ) as Record<ScreenSize, string>,
  },
} as const;

export type MDSMediaQueries = typeof mdsMediaQueriesValue;

// Function version for backward compatibility
export const mdsMediaQueries = () => mdsMediaQueriesValue;
